var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { GameComponent } from '../game/game.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MessageType } from '../shared/model/message-type';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { GameStatus } from '../shared/model/game-status';
var ScattergoriesComponent = /** @class */ (function (_super) {
    __extends(ScattergoriesComponent, _super);
    function ScattergoriesComponent(socketService, cookieService, router, resolver, httpClient, cdr) {
        var _this = _super.call(this, socketService, cookieService, router, resolver) || this;
        _this.httpClient = httpClient;
        _this.cdr = cdr;
        _this.separatorKeysCodes = [ENTER, COMMA];
        /* Submit Mode Variables */
        _this.submitMode = false;
        _this.submissions = {};
        /* Wait Mode Variables */
        _this.waitMode = false;
        /* Vote Mode Variables */
        _this.voteMode = false;
        _this.votes = [];
        _this.voteSubmissions = {};
        _this.voteModeSubmissions = {};
        _this.submitterNames = [];
        return _this;
    }
    ScattergoriesComponent.prototype.messageHandler = function (message) {
        if ((message.action === MessageType.Prompt ||
            message.content.status === GameStatus.InProgress) &&
            !this.categories) {
            this.waitMode = false;
            this.showReady = false;
            this.showWaiting = false;
            this.letter = message.content.letter;
            this.voteSubmissions = message.content.submissions;
            this.categories = message.content.cattergories;
            this.expiration = message.content.expiration;
            this.timeLimit = message.content.timeLimit;
            if (message.content.voteMode) {
                this.buildVoteMode();
            }
            else {
                this.buildSubmitMode();
            }
        }
    };
    ScattergoriesComponent.prototype.sendResponse = function (message) {
        var submission = {
            answer: message,
            submitMode: this.submitMode,
            voteMode: this.voteMode
        };
        this.submitMode = false;
        this.voteMode = false;
        this.waitMode = true;
        this.categories = null;
        this.socketService.send({
            from: this.user,
            content: submission,
            action: MessageType.Response,
            gameId: this.gameId
        });
    };
    ScattergoriesComponent.prototype.addSubmission = function (event, category) {
        var inputDOM = event.input;
        var word = event.value.toLowerCase().trim();
        if (this.submissions[category].length < 3 &&
            !this.submissions[category].includes(word) &&
            word !== '') {
            this.submissions[category].push(word);
        }
        if (inputDOM) {
            inputDOM.value = '';
        }
        this.cdr.detectChanges();
    };
    ScattergoriesComponent.prototype.removeSubmission = function (submittedWord, category) {
        var index = this.submissions[category].indexOf(submittedWord);
        if (index >= 0) {
            this.submissions[category].splice(index, 1);
        }
        this.cdr.detectChanges();
    };
    ScattergoriesComponent.prototype.buildVoteMode = function () {
        var _this = this;
        this.submitterNames = Object.keys(this.voteSubmissions).filter(function (name) {
            return name !== _this.user.name;
        });
        for (var i = 0; i < this.submitterNames.length; i++) {
            var submitter = this.submitterNames[i];
            for (var a = 0; a < this.categories.length; a++) {
                var cat = this.categories[a];
                this.voteSubmissions[submitter].submission[cat].forEach(function (submission) {
                    submission.voterName = _this.user.name;
                    if (!_this.voteModeSubmissions[submission.category]) {
                        _this.voteModeSubmissions[submission.category] = [];
                    }
                    _this.voteModeSubmissions[submission.category].push(submission);
                });
            }
        }
        this.submitMode = false;
        this.voteMode = true;
    };
    ScattergoriesComponent.prototype.buildSubmitMode = function () {
        var _this = this;
        this.categories.forEach(function (cat) {
            _this.submissions[cat] = [];
        });
        this.submitMode = true;
        this.voteMode = false;
    };
    ScattergoriesComponent.prototype.submitSubmissions = function () {
        this.sendResponse(this.submissions);
    };
    ScattergoriesComponent.prototype.submitVote = function () {
        this.sendResponse(this.voteModeSubmissions);
    };
    ScattergoriesComponent.prototype.timerChangeHandler = function (event) {
        if (event.status.ended) {
            if (this.voteMode) {
                this.submitVote();
            }
            else {
                this.submitSubmissions();
            }
        }
    };
    return ScattergoriesComponent;
}(GameComponent));
export { ScattergoriesComponent };
